module.exports = __webpack_public_path__ + "static/media/f_hairstyle_curly_medium_back_vector.02e3f70b.svg";